<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{'FormulaBuilder.Title' | translate}}</h2>
  </div>
  <div class="cald_content formula-builder-content page-content-wrapper">
    <mat-tab-group>
      @if (initData.formulaBuilderType === FormulaBuilderType.Product && initData.isTrigger) {
        <mat-tab>
          <ng-template mat-tab-label>
            <div><span>{{ actionTabTranslationKey | translate}}</span></div>
          </ng-template>
          <div class="col-12 component-wrapper">
            <cpq-select [type]="SelectType.Searchable" [id]="'selectAction'"
              [label]="{key: actionStep1TranslationKey, placeholder:'FormulaBuilder.StartTyping'}"
              [items]="lookups.actions" [(ngModel)]="formula.selectedAction" (ngModelChange)='onSelectedVariableChange()'
            [setFirstOptionSelected]='false'></cpq-select>
          </div>
          <div class="col-12 component-wrapper">
            <label>{{ 'FormulaBuilder_ActionsAndConditions_Step2Message' | translate}}</label>
            <cpq-list-box name="actionAttributeValues" id="selectactionAttribute"
              [items]="lookups.actionAttributes" [(selectedItems)]="formula.selectedActionAttributes"
              [hasSearch]="true" [searchLabel]='{placeholder:"FormulaBuilder.StartTyping"}'>
            </cpq-list-box>
            <button id="insertAction" type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="insertAction()">{{ actionInsertButtonTranslationKey | translate}}</button>
          </div>
          <div class="component-wrapper operator-background">
            <div class="col-12">
              <cpq-select #operations="ngModel" [type]="SelectType.Simple" [id]="'selectOperator'"
                [label]="{key: 'FormulaBuilder.SelectOperator'}" [items]="lookups.operations"
                [(ngModel)]="formula.selectedOperation" [control]="operations">
              </cpq-select>
              <button id="insertOperator" type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="insertOperator()">{{'syntaxchecker_HMTL_InsertOperatorButtonLabel' | translate}}</button>
            </div>
          </div>
        </mat-tab>
      }

      @if (initData.formulaBuilderType === FormulaBuilderType.Product) {
        <mat-tab>
          <ng-template mat-tab-label>
            <div><span>{{'syntaxchecker_HTML_Variables' | translate}}</span></div>
          </ng-template>
          <div class="col-12 component-wrapper">
            <cpq-select [type]="SelectType.Searchable" [id]="'selectedVariableId'"
              [label]="{key: 'FormulaBuilder_Variables_Step1Message', placeholder:'FormulaBuilder.StartTyping'}" #selectedVariableId="ngModel"
              [items]="lookups.variables" [(ngModel)]="formula.selectedVariable" (ngModelChange)='onSelectedVariableChange()'
              [setFirstOptionSelected]='false'>
            </cpq-select>
          </div>
          <div class="col-12 component-wrapper">
            <cpq-select [disabled]="!canVariableContainAttribute || formula.selectedVariable === null || lookups.attributes.length === 0" [type]="SelectType.Searchable"
              [id]="'selectVariableAttribute'" #selectVariableAttribute
              [label]="{key: 'FormulaBuilder_Variables_Step2Message', placeholder:'FormulaBuilder.StartTyping'}"
              [items]="lookups.attributes" [(ngModel)]="formula.selectedAttribute" (ngModelChange)='onSelectedAttributeChange()'
              [setFirstOptionSelected]='false'>
            </cpq-select>
          </div>
          <div class="col-12 component-wrapper">
            <cpq-select [disabled]="!canVariableContainAttribute || this.formula.selectedAttribute === null || lookups.attributeValues.length === 0"
              [type]="SelectType.Searchable" [id]="'selectVariableAttributeValue'" #selectVariableAttributeValue
              [label]="{key: 'FormulaBuilder_Variables_Step3Message', placeholder:'FormulaBuilder.StartTyping'}"
              [items]="lookups.attributeValues" [(ngModel)]="formula.selectedAttributeValue"
              [setFirstOptionSelected]='false'>
            </cpq-select>
            @if (!isSpecialTagSelected) {
              <button type="button" id="insertVariable"
              class="btn btn-secondary fiori3-btn-secondary" (click)="insertVariable()">{{'syntaxchecker_HMTL_InsertVariableButtonLabel' | translate}}</button>
            }
            @if (isSpecialTagSelected) {
              <button type="button" id="insertSpecialTag"
              class="btn btn-secondary fiori3-btn-secondary" (click)="constructSpecialTag()">{{ specialTagTranslationKey | translate}}</button>
            }
          </div>
          <div class="component-wrapper operator-background">
            <div class="col-12">
              <cpq-select #operations="ngModel" [type]="SelectType.Simple" [id]="'selectOperator'"
                [label]="{key: 'FormulaBuilder.SelectOperator'}" [items]="lookups.operations"
                [(ngModel)]="formula.selectedOperation" [control]="operations">
              </cpq-select>
              <button id="insertOperator" type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="insertOperator()">{{'syntaxchecker_HMTL_InsertOperatorButtonLabel' | translate}}</button>
            </div>
          </div>
        </mat-tab>
      }

      @if (initData.formulaBuilderType === FormulaBuilderType.Product) {
        <mat-tab>
          <ng-template mat-tab-label>
            <div><span>{{'syntaxchecker_HTML_Sequences' | translate}}</span></div>
          </ng-template>
          <div class="page-content-wrapper">
            <div class="col-12 component-wrapper">
              <cpq-select #sequence='ngModel' [type]="SelectType.Simple" [id]="'selectSequenceOperator'"
                [label]="{key: 'FormulaBuilder_Sequences_Step1Message', placeholder:'FormulaBuilder.StartTyping'}"
              [items]="lookups.sequenceOperators" [(ngModel)]="formula.selectedSequenceOperator" [control]="sequence"></cpq-select>
            </div>
            <div class="col-12 component-wrapper">
              <cpq-select #sequenceOperator="ngModel" [type]="SelectType.Simple" [id]="'selectSequence'"
                [label]="{key: 'FormulaBuilder_Sequences_Step2Message', placeholder:'FormulaBuilder.StartTyping'}"
              [items]="lookups.sequences" [(ngModel)]="formula.selectedSequence" [control]="sequenceOperator"></cpq-select>
              <button type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="insertSequenceOperator()">{{'syntaxchecker_HMTL_InsertSequenceButtonLabel' | translate}}</button>
            </div>
            <div class="component-wrapper operator-background">
              <div class="col-12">
                <cpq-select #operations="ngModel" [type]="SelectType.Simple" [id]="'selectOperator'"
                  [label]="{key: 'FormulaBuilder.SelectOperator'}" [items]="lookups.operations"
                  [(ngModel)]="formula.selectedOperation" [control]="operations">
                </cpq-select>
                <button id="insertOperator" type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="insertOperator()">{{'syntaxchecker_HMTL_InsertOperatorButtonLabel' | translate}}</button>
              </div>
            </div>
          </div>
        </mat-tab>
      }

      @if (initData.formulaBuilderType === FormulaBuilderType.Cart) {
        <mat-tab>
          <ng-template mat-tab-label>
            <div><span>{{'syntaxchecker_HTML_Tags' | translate}}</span></div>
          </ng-template>
          <div class="col-12 component-wrapper">
            <cpq-select [type]="SelectType.Searchable" [id]="'selectCartTag'"
              [label]="{key: 'FormulaBuilder_Tags_Step1Message', placeholder:'FormulaBuilder.StartTyping'}"
              [items]="lookups.cartActions" [(ngModel)]="formula.selectedCartAction" (ngModelChange)='onSelectedCartActionChange()'
            [setFirstOptionSelected]='false'></cpq-select>
          </div>
          <div class="col-12 component-wrapper">
            <cpq-select [disabled]="formula.selectedCartActionParameter === null || lookups.actionParameters.length === 0"
              #actionParameters="ngModel" [type]="SelectType.Simple" [id]="'selectActionParamter'"
              [label]="{key: 'FormulaBuilder_Tags_Step2Message', placeholder:'FormulaBuilder.StartTyping'}"
              [items]="lookups.actionParameters" [(ngModel)]="formula.selectedCartActionParameter">
            </cpq-select>
            @if (!isSpecialTagSelected) {
              <button id="insertCartTag" type="button"
              class="btn btn-secondary fiori3-btn-secondary" (click)="insertCartAction()">{{'syntaxcheckerCart_HMTL_InsertTagButtonLabel' | translate}}</button>
            }
            @if (isSpecialTagSelected) {
              <button id="insertSpecialTag" type="button"
              class="btn btn-secondary fiori3-btn-secondary" (click)="constructSpecialTag()">{{ specialTagTranslationKey | translate}}</button>
            }
          </div>
          <div class="component-wrapper cart-action-operator-background">
            <div class="col-12">
              <cpq-select #operations="ngModel" [type]="SelectType.Simple" [id]="'selectOperator'"
                [label]="{key: 'FormulaBuilder.SelectOperator'}" [items]="lookups.operations"
                [(ngModel)]="formula.selectedOperation" [control]="operations">
              </cpq-select>
              <button id="insertOperator" type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="insertOperator()">{{'syntaxchecker_HMTL_InsertOperatorButtonLabel' | translate}}</button>
            </div>
          </div>
          <div class="component-wrapper">
            <div class="alert alert-info">
              <span class="sap-icon">&#xe202;</span>
              <div class="content">
                {{'syntaxcheckerCart_HTML_ConditionExplanationLabel1or0' | translate}}
              </div>
            </div>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
    <div class="col-12 component-wrapper">
      <cpq-textarea #formulaTextAreaElement #formulaTextArea="ngModel" [id]="'resultFormula'"
        [control]="formulaTextArea" [name]="'formulaTextArea'"
      [label]="{key:'syntaxcheckerCart_HTML_FormulaLabel'}" [(ngModel)]="formula.conditionFormula"></cpq-textarea>
      <div class="flex">
        <div class="flex">
          @if (showParseValidationMessage) {
            <span id="parseValidationMessage"
              title="{{syntaxCheckResponse.message}}" class="parse-formula-message">{{syntaxCheckResponse.message}}
            </span>
          }
        </div>
        <div>
          <button type="button" class="btn btn-secondary fiori3-btn-secondary" id="checkSyntax"
            (click)="checkSyntax()">{{'syntaxchecker_HMTL_CheckSyntaxButtonLabel' | translate}}
          </button>
          <button type="button" class="btn btn-secondary fiori3-btn-secondary" id="visualize"
            (click)="visualize()">{{'syntaxchecker_HMTL_Visualize' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" id="saveFormula"
      (click)="save()">{{'Admin.Msg.UpdateButton' | translate}}
    </button>
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" id="cancel" (click)="cancel()">{{'Msg.Close' | translate}}</button>
  </div>
</div>

